/*  seal-login-gate.js  –  Adds to cart *then* jumps to login  */
(function () {
  const CART_LOGIN_URL = '/account/login?return_url=%2Fcart';

  document.addEventListener('DOMContentLoaded', () => {
    const addBtn   = document.querySelector('[name="add"].product-form__submit');
    const loginBtn = document.querySelector('[data-subscribe-login]');
    if (!addBtn || !loginBtn) return;           // nothing to do on non-product pages

    /* ---------- click handler for the login / create-account CTA ---------- */
    loginBtn.addEventListener('click', (ev) => {
      ev.preventDefault();                      // stop the normal navigation
      addCurrentSelectionToCart().finally(() => {
        window.location.href = CART_LOGIN_URL;  // go log in (or sign up) -> /cart
      });
    });

    /* ---------- button-toggle helper ---------- */
    const queryPlan = () =>
      document.querySelector('.sealsubs-target-element input[name="selling_plan"]:checked');

    function flipButtons(isSub, loggedIn) {
      const needsLogin = isSub && !loggedIn;
      addBtn.style.display   = needsLogin ? 'none' : '';
      loginBtn.style.display = needsLogin ? ''     : 'none';
    }

    /* ---------- event wiring ---------- */
    const loginState = window.customerLoggedIn === true;
    flipButtons(Boolean(queryPlan()), loginState);

    document.addEventListener('sealsubs:selling_plan_changed', (e) =>
      flipButtons(Boolean(e.detail?.selling_plan_id), loginState)
    );
    document.addEventListener('sealsubs:subscription_widget_created', () =>
      flipButtons(Boolean(queryPlan()), loginState)
    );

    /* ---------- add-to-cart helper ---------- */
    function addCurrentSelectionToCart() {
      /* current variant, qty, and selling-plan */
      const productForm = addBtn.closest('form');
      if (!productForm) return Promise.resolve();       // fallback
      const variantId  = productForm.querySelector('input.product-variant-id')?.value;
      const planId     = queryPlan()?.value;
      const qtyInput   = productForm.querySelector('input.quantity__input');
      // const qty        = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const qty        = productForm.querySelector('input.quantity')?.value || 1;

      if (!variantId || !planId) return Promise.resolve(); // nothing to add

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, selling_plan: planId }),
      }).catch((err) => console.warn('[SealGate] add-to-cart failed', err));
    }
  });
})();
